import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";

const LANGS = ["es", "en", "it"];
const SITE = "Gusto y Ciencia";

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

const setMeta = (attr, key, content) => {
  const el = upsert(`meta[${attr}="${key}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute(attr, key);
    return m;
  });
  el.setAttribute("content", content);
};

const setLink = (rel, href, hreflang) => {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  const el = upsert(sel, () => {
    const l = document.createElement("link");
    l.setAttribute("rel", rel);
    if (hreflang) l.setAttribute("hreflang", hreflang);
    return l;
  });
  el.setAttribute("href", href);
};

/** Aggiorna title, description, canonical, hreflang, Open Graph e JSON-LD della pagina corrente. */
export const Seo = ({ title, description, image, type = "website", jsonLd, noindex = false }) => {
  const { lang } = useLanguage();
  const { pathname } = useLocation();

  useEffect(() => {
    const origin = window.location.origin;
    const url = `${origin}${pathname}`;
    const fullTitle = title ? `${title} · ${SITE}` : SITE;
    const img = image ? (image.startsWith("/") ? origin + image : image) : `${origin}/giada-v2.jpg`;

    document.title = fullTitle;
    document.documentElement.lang = lang;
    setMeta("name", "description", description || "");
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:image", img);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("property", "og:locale", { es: "es_ES", en: "en_GB", it: "it_IT" }[lang]);
    setMeta("name", "twitter:card", "summary_large_image");
    setLink("canonical", url);
    LANGS.forEach((l) => setLink("alternate", `${url}?lang=${l}`, l));
    setLink("alternate", url, "x-default");

    let script = document.head.querySelector('script[data-seo="jsonld"]');
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.dataset.seo = "jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, image, type, jsonLd, noindex, lang, pathname]);

  return null;
};
